export default __webpack_public_path__ + "aa63b67dba15072b7ab54caeb989543e.svg";